import useProposalDrawer from 'ecp/app/Proposals/hooks/useProposalDrawer'
import useThisStep from './useThisStep'

function useProposalDrawerWithContext () {
  const { department, step } = useThisStep()
  return useProposalDrawer({ department, step })
}

export default useProposalDrawerWithContext
